var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Have You Wired Your Funds to the Title Company?"}},[_c('input-radio-boolean',{attrs:{"name":"have_you_wired_funds","value":_vm.closing.have_you_wired_funds,"true":"Yes","false":"No","read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }